import React from "react";

const Skills = () => {
  const skills = [
    "node", "javascript", "express", "postgresql", "react", "redux", "git", "css", "html", "javascript", "python", "r",
    "office", "excel", "powerpoint", "hudl", "wyscout",
    "nacsport", "keynote"
  ];

  return (
    <section id="skills">
      <h2>Skills</h2>
      <div id="skills-container">
        {skills.map((skill) => (
          <img
            key={skill}
            src={`/images/${skill}.png`}
            alt={`${skill} logo`}
            className="logo"
          />
        ))}
      </div>
    </section>
  );
};

export default Skills;
